<div class="auth-flex-columns">
  <div class="auth-inner-wrapper min-height">
    <img (click)="closeDialog()" class="close-icon" src="./../../../../assets/images/icons/close.svg" alt="close-icon">
      <div class="form-block">
        <div class="heading ">
          <h1 class="page-title">Reset password</h1>
          <p class="auth-page-description">Please enter new password.</p>
        </div>
        <form [formGroup]="resetPasswordForm" >

          <app-inline-input-control [type]="'password'"  [control]="resetPasswordForm.controls[ResetPasswordFields.Password]" [label]="'New password'" [name]="ResetPasswordFields.Password"></app-inline-input-control>

          <app-inline-input-control [type]="'password'"  [control]="resetPasswordForm.controls[ResetPasswordFields.RepeatNewPassword]" [label]="'Repeat new password'" [name]="ResetPasswordFields.RepeatNewPassword"></app-inline-input-control>
  
          
          <button (click)="confirmPasswordReset()" [disabled]="!resetPasswordForm.valid || 
          resetPasswordForm.get(ResetPasswordFields.RepeatNewPassword)?.value !== 
          resetPasswordForm.get(ResetPasswordFields.Password)?.value" class="c-button secondary w-100" pButton pRipple>
            <span>Reset password</span>
            <img class="btn-icon ml-8-px" src="./../../../../assets/images/icons/arrow-right-white.svg" alt="sign-in">
            </button>
            <div class="extra-links">
              <p class="line">
                <span>Go back <a (click)="closeDialog()">Home</a></span>
              </p>
            </div>
          </form>
        </div>
      </div>
      <div class="banner-container">
        <app-current-banner [minWidth]="380"[authDialogStyles]="true"></app-current-banner>
      </div>
    </div>
    